// Remove Stats.js from official postings so it doesn't get included in vendor.bundle.js
// import Stats from 'stats.js';

// config is used through most of the game files and shoulc contain alll games constants
import config from './config';

// contains helper function related to the game or Phaser itself

// import SdkEmulator from './utils/SdkEmulator';
import DataManager from './utils/DataManager';
import SoundManager from './utils/SoundManager';

import ChildCounter from './utils/ChildCounter';

// The scenes that make up our game
import Boot from './scene/Boot';
import Preload from './scene/Preload';
import Intro from './scene/Intro';
import Play from './scene/Play';
import Settings from './scene/Settings';
import Store from './scene/Store';
import Continue from './scene/Continue';
import Score from './scene/Score';

import WebFontLoaderPlugin from './utils/webfontloader/rexwebfontloaderplugin.js';
import LocalisationManager from './utils/LocalisationManager';
import DeviceOrientationChecker from './utils/DeviceOrientationChecker';

let windowDomReady = false;
let gameStarted = false;

// for production
let sdkReady = true;
let SDK_REF = null;

// for emulator
// let sdkReady = true;
// let SDK_REF = new SdkEmulator();
// window['PlayPromise'].then(function (sdk) {
//   SDK_REF = sdk;
//   SDK_REF.debug('Play Promise Success');
//   sdkReady = true;
//   startGame();
// });

let game;
var ua = navigator.userAgent;
let isDesktop = !/Mobi|Android|iP[ao]d|iPhone/i.test(ua) && (!/Mac/.test(ua) || !navigator.maxTouchPoints || navigator.maxTouchPoints <= 1);

function PauseGame(){
  if(game){
    if(game.scene.isActive("Play")){
      game.scene.getScene("Play").scene.launch('Settings');
    }
  }
}

function ResumeGame(){
  
}

function onWindowBlur() {
  PauseGame();
};

function onWindowFocus() {
  ResumeGame();
};

function onVisibilityChange() {
  if(document.visibilityState == 'hidden'){
      PauseGame();
  }
  else{
      ResumeGame();
  }

};

prepare();

function prepare(){
  if(isDesktop){
    startGame();
  } 
  else{
    var orientationCheck = new DeviceOrientationChecker(false, document.body, startGame, PauseGame);
  }
  
}

function startGame () {
  
  if (gameStarted) {
    return;
  }

  gameStarted = true;
  
  var stage = document.createElement('div');
  stage.id = 'stage-container';  
  stage.style.width = "100%";
  stage.style.height = "100%";
  stage.style.position = "relative";
  stage.style.overflow = "hidden";
  stage.style["-webkit-touch-callout"] = "none";
  stage.style["-webkit-user-select"] = "none";
  stage.style["-webkit-tap-highlight-color"] = "rgba(0, 0, 0, 0)";
  document.body.appendChild(stage);
  // console.log('startGame');
  
  let WIDTH = 768;
  let HEIGHT = Math.max(((window.innerHeight / window.innerWidth) * WIDTH), ((window.innerWidth / window.innerHeight) * WIDTH));
  HEIGHT = HEIGHT > 1663 ? 1663 : HEIGHT;
  
  if(isDesktop){
    HEIGHT = 1024;
  }

  config.WIDTH = WIDTH;
  config.HEIGHT = HEIGHT;
  config.THIRD_WIDTH = config.WIDTH / 3;
  config.CENTER_X = config.WIDTH / 2;
  config.CENTER_Y = config.HEIGHT / 2;
  config.ASPECT_RATIO = config.WIDTH / config.HEIGHT;

  game = new Phaser.Game({
    type: Phaser.CANVAS,
    backgroundColor: 0x3c3c3c,
    resolution: config.DEVICE_PIXEL_RATIO,
    parent: stage.id,
    scale:{
      mode: isDesktop && window.innerWidth > window.innerHeight ? Phaser.Structs.Size.HEIGHT_CONTROLS_WIDTH : Phaser.Structs.Size.WIDTH_CONTROLS_HEIGHT,
      //autoCenter: Phaser.Scale.CENTER_BOTH,
      width: config.WIDTH,
      height: config.HEIGHT,
      autoRound: true
  },
    plugins: {
      global: [
          {
              key: 'WebFontLoader',
              plugin: WebFontLoaderPlugin,
              start: true
          }
      ]
  },
  });

  game.dataManager = new DataManager();
  game.localisationManager = new LocalisationManager();

  game.scene.add('Boot', Boot);
  game.scene.add('Preload', Preload);
  game.scene.add('Intro', Intro);
  game.scene.add('Play', Play);
  game.scene.add('Settings', Settings);
  game.scene.add('Store', Store);
  game.scene.add('Continue', Continue);
  game.scene.add('Score', Score);
  game.scene.add('SoundManager', SoundManager);
  game.scene.start('Boot');
  
  game.isDesktop = isDesktop; 
  
  window.addEventListener("blur", onWindowBlur);
  window.addEventListener("focus", onWindowFocus);
  document.addEventListener("visibilitychange", onVisibilityChange);

  //let resizeGameBound = resizeGame.bind(game);
  //window.focus();
  // resizeGameBound();
  // window.addEventListener('resize', resizeGameBound);

  if (__DEV__) {
    new ChildCounter(game);
  }
}
